import React, { useContext, useEffect, useState } from 'react'
import authContext from '../context/authContext/authContext';
import axios from 'axios';
import successHandle from '../utils/successHandle';
import errorHandle from '../utils/errorHandle';
import Timeline from '../components/Timeline';
const GET_USER_HISTORY_ENDPOINT = process.env.REACT_APP_API_URL + "/api/user/getUserHistory";

const initialState = {
  loading: false,
  userHistory: []
}
const AccountHistory = () => {
  const { getConfig } = useContext(authContext);

  const config = getConfig();

  const [state, setCompleteState] = useState(initialState);
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const getUserHistory = async () => {
    if (state.loading) {
      return;
    }

    setState({ loading: true })
    await axios.get(GET_USER_HISTORY_ENDPOINT, config)
      .then((res) => {
        setState({ loading: false })
        let { history } = res.data;
        const userHistory = history.map((item, index) => ({
          ...item,
          side: index % 2 === 0 ? "left" : "right"
        }));
        setState({ userHistory, loading: false });
      })
      .catch((err) => {
        setState({ loading: false })
        errorHandle(err)
      }
      )
  }
  useEffect(() => {
    getUserHistory();
  }, [])

  return (
    <div className='container mt-5'>
      <div className='p-5'>
        <div className='section-title'>
          <p>Account History</p>

          {!state.userHistory?.length && (
            <div className='text-center'>No Account history available</div>
          )}
        </div>
        <div className='render-time-line'>
          <Timeline timeLineData={state.userHistory || []} />
        </div>
      </div>
    </div>
  )
}

export default AccountHistory
